module.exports = __webpack_public_path__ + "static/media/BabyCourse_Desktop_Main_3.3351a565.jpf";